import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import { v4 as uuidv4 } from "uuid";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import eventAdvertise from "../../../store/actions/eventAdvertise";
import SeparationActive from "./SeparationActive";

const PieChartReport = ({
  dataChartSeparation,
  eventDataChart,
  separationActive,
}) => {
  const [data, setData] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  useEffect(() => {
    if (Object.keys(dataChartSeparation).length != 0) {
      let dataPieChar = [];
      let index = 1;
      let newTotalValue = 0;
      for (let key in dataChartSeparation) {
        let dataChartSeparationItem = dataChartSeparation[key];
        newTotalValue += parseInt(dataChartSeparationItem[eventDataChart]);
        dataPieChar.push({
          ID: uuidv4(),
          name: key,
          value: parseInt(dataChartSeparationItem[eventDataChart]),
          color: "#" + Math.floor(Math.random() * 16777215).toString(16),
          opacity: 1,
        });

        index++;
      }
      setTotalValue(newTotalValue);
      setData(dataPieChar);
    }
  }, [dataChartSeparation]);

  const customizedTooltip = ({ payload, active }) => {
    if (!active) {
      return <></>;
    }
    if (payload == undefined) {
      return <></>;
    }

    if (payload[0] == undefined) {
      return <></>;
    }

    let label = payload[0].name;
    switch (separationActive) {
      case SeparationActive.ADVERTISE:
        label = (
          <>
            <span>شماره تبلیغ :</span>
            <span className="text-left">
              {" "}
              {helpersNumbers.toPersianNum(label)}
            </span>
          </>
        );
        break;
      case SeparationActive.PUBLISHER:
        label = <div className="text-left">{label.replace("http://", "")}</div>;
        break;
      case SeparationActive.TIME:
        if (label.includes(":")) {
          label = helpersNumbers.toPersianNum(
            label.replace("-", " تا ").split(" ").reverse().join(" ")
          );
        } else {
          label = helpersNumbers
            .toPersianNum(
              helpersTime.convertGregorianToJalali(label, "MMMM DD ddd")
            )
            .split(" ")
            .reverse()
            .join(" ");
        }
        break;
    }

    const partCircleHoverBackgroundColor = payload[0].payload.fill;
    return (
      <div className="card" id="box-details-pie-chart" dir="rtl">
        <div className="card-body p-3">
          <div className="text-center">{label}</div>
          <div className="my-2 hr-bottom-label"></div>
          <div className="d-flex pb-3">
            <span className="px-2">
              <i
                className="fa fa-circle"
                style={{ color: partCircleHoverBackgroundColor }}
              ></i>
            </span>
            <span className="pl-2">
              {
                eventAdvertise.eventAdvertisePersian[
                  eventDataChart.toUpperCase()
                ]
              }{" "}
              :
            </span>
            <span>{helpersNumbers.toPersianNum(payload[0].value)}</span>
          </div>
          <div className="d-flex  ">
            <span className="px-2">
              <i
                className="fa fa-circle"
                style={{ color: partCircleHoverBackgroundColor }}
              ></i>
            </span>
            <span className="pl-2">درصد : </span>
            <span>
              {helpersNumbers.toPersianNum(
                Math.floor((payload[0].value / totalValue) * 1000) / 10
              )}
              %
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ResponsiveContainer height="100%" width="100%">
        <PieChart>
          <Pie data={data} labelLine={false} outerRadius={120} dataKey="value">
            {data.map((entry, index) => {
              return (
                <Cell
                  onMouseLeave={(e) => {
                    setData((prevState) => {
                      return prevState.map((item) => {
                        item.opacity = 1;
                        return item;
                      });
                    });
                  }}
                  style={{ opacity: entry.opacity }}
                  key={`cell-${index}`}
                  cursor="pointer"
                  fill={entry.color}
                />
              );
            })}
          </Pie>
          <Tooltip content={customizedTooltip} />
        </PieChart>
      </ResponsiveContainer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    dataChartSeparation: state.reportCampaign.data_chart_separation,
    eventDataChart: state.reportCampaign.event_data_chart,
    separationActive: state.reportCampaign.which_separation_active,
  };
};
export default connect(mapStateToProps, null)(PieChartReport);
